const PRUEBAS = 'https://190.61.31.221:8443';
const PRODUCCION = 'https://190.61.31.224:8443';
const AWS = 'https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev';
// const AWS = 'http://localhost:3001/dev';

/** API de solicitud nota crédito (evita CORS en local vía proxy en package.json). */
const CREDIT_NOTE_API_ORIGIN =
  'https://zx6pdfpg24.execute-api.us-east-1.amazonaws.com';

export const URL_SERVICIO = PRODUCCION;
export const URL_AWS = AWS;
export const URL_EMPLOYEE =
  'https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev';

export const URL_CREDIT_NOTE_REQUEST = `${CREDIT_NOTE_API_ORIGIN}/prod/credit-note-request`;
export const URL_INVOICE_QR_READ = `${CREDIT_NOTE_API_ORIGIN}/prod/read-qr-from-image`;